import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import css from './Toast.css';

const Toast = ({ icon, onClose, children, className }) => (
    <div className={classNames(css.toast, className)} role="status">
        <Icon name={icon} size={IconSizes.SMALL} className={css.toastIcon} interactive={false} />
        <span className={css.toastText}>{children}</span>
        {onClose && <Icon name="x" size={IconSizes.SMALL} className={css.toastClose} onClick={onClose} />}
    </div>
);

Toast.propTypes = {
    icon: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

Toast.defaultProps = {
    icon: 'info-circle',
};

export default Toast;
